const formParamNotificationWebhook = {
  deleteWebhook: 'Eliminar Webhook',
  deleteWebhookMessage: '¿Realmente desea eliminar el webhook?',
  subtitle: 'Los webhooks se utilizan para permitir la comunicación entre dos aplicaciones y enviar notificaciones casi en tiempo real.',
  invalidUrl: 'URL no válida',
  showActionsLabel: 'Activar notificaciones de acciones',
  actionsHelperText: 'Las notificaciones de acciones incluyen: creación, edición, cambio de estado y eliminación.',
  actionsHelperText2: 'Estas serán enviadas con un POST a {url}(por ejemplo, https://geequip.sistemasgap.com.br/actions)',
  showServicesLabel: 'Activar notificaciones de servicios',
  servicesHelperText: 'Las notificaciones de servicios incluyen: creación, edición y eliminación.',
  servicesHelperText2: 'Estas serán enviadas con un POST a {url} (por ejemplo, https://geequip.sistemasgap.com.br/services)',
  createWebhook: 'Crear Webhook',
  active: 'Activo',
  apiKeyHelperText: 'Los payloads entregados a su url contendrán el header: {"x-api-key": {suApiKey}}',
};

export default formParamNotificationWebhook;
